import Image from "./image"

export default class Teacher {
    readonly id: number
    readonly name: string
    readonly catch: string
    readonly pointCount: string
    readonly image: Image
  
    constructor(data: { [key: string]: any }) {
      this.id = data.id
      this.name = data.name
      this.catch = data.catch
      this.pointCount = data.pointCount

      if (data.image) {
        this.image = new Image(data.image)
      }
    }
  }